<script lang="ts">
  export interface Props {
    list?: HeaderItemNotification[],
  }
</script>

<script setup lang="ts">
import type { HeaderItemNotification } from './TheHeader.vue';

const props = withDefaults(defineProps<Props>(), {
  list: () => [],
});
</script>

<template>
  <div class="header-notification">
    <span
      v-for="(notification, index) in list.filter((notification) => notification.count > 0)"
      :key="index"
      :class="[
        'header-notification__item',
        `header-notification__item_${notification.type}`
      ]"
    >
      {{ notification.count }}
    </span>
  </div>
</template>

<style lang="scss">
.header-notification {
  position: absolute;
  top: 2px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  &__item {
    padding: 2px 4px;
    border-radius: 200px;
    font-size: 10px;
    line-height: 10px;
    font-weight: 500;
    margin: 0 2px;

    &_positive {
      background-color: var(--notifications-positive);
      color: var(--text-body-invert);
    }
    &_negative {
      background-color: var(--notifications-negative);
      color: var(--text-body-invert);
    }
    &_neutral {
      background-color: var(--notifications-neutral);
      color: var(--text-body);
    }
    &_warning {
      background-color: var(--notifications-warning);
      color: var(--text-body-invert);
    }
  }
}
</style>
